import React from "react";
import { Activity } from "lucide-react";
import { useOps } from "@/lib/opsCards";

const ago = (iso) => {
  const s = Math.max(1, Math.round((Date.now() - new Date(iso).getTime()) / 1000));
  if (s < 60) return `${s}s ago`;
  if (s < 3600) return `${Math.round(s / 60)}m ago`;
  if (s < 86400) return `${Math.round(s / 3600)}h ago`;
  return new Date(iso).toLocaleDateString();
};

// “Recent activity” feed on the main board — every quick-form save lands here.
export default function RecentActivityPanel() {
  const { activity, ready } = useOps();
  if (!ready) return null;
  return (
    <section data-testid="ops-activity-panel" className="nds-card p-4 mb-6">
      <div className="flex items-center gap-2 font-mono text-[0.6rem] tracking-[0.22em] uppercase text-brand-cyan mb-3">
        <Activity className="w-3.5 h-3.5" /> Recent activity
      </div>
      {activity.length ? (
        <ul className="grid gap-1.5 sm:grid-cols-2 lg:grid-cols-3">
          {activity.slice(0, 9).map((a) => (
            <li key={a.id} data-testid={`ops-activity-${a.id}`} className="flex items-baseline gap-2 text-xs text-slate-300 min-w-0">
              <span className="font-mono text-slate-500 shrink-0 whitespace-nowrap">{ago(a.at)}</span>
              <span className="truncate">{a.summary}</span>
              <span className="text-slate-500 shrink-0 hidden md:inline">· {a.actor?.name?.split(" ")[0]}</span>
            </li>
          ))}
        </ul>
      ) : <p data-testid="ops-activity-empty" className="text-xs text-slate-500">Nothing yet — entries saved from card popups show up here.</p>}
    </section>
  );
}
